import "../style/mobile/M_Header.css";
import bag_icon from "../../assets/header/Group header-icon-1.png";
// import notif_icon from '../../assets/header/Group header-icon-2.png';
import { AiOutlineMenu } from "react-icons/ai";

import { useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { actionCreators } from "../../redux/index";
import { Link } from 'react-router-dom';

const M_Header = () => {
  const dispatch = useDispatch();
  const { open_Mnav } = bindActionCreators(actionCreators, dispatch);

  return (
    <div className="m-header">
      <div className="m-header-p1">
        <Link to={`/dashboard/cart`} className="m-header-icon-container">
          <img src={bag_icon} alt="bag-icon" />
          <div className="m-hic-badge m-hic-badge-bag">1</div>
        </Link>
        {/* <div className="m-header-icon-container">
          <img src={notif_icon} alt="notif-icon" />
          <div className="m-hic-badge m-hic-badge-notif">2</div>
        </div> */}
      </div>
      <div className="m-header-logo">AZMOON</div>
      <AiOutlineMenu
        className="m-header-menu-btn"
        onClick={() => open_Mnav()}
      />
    </div>
  );
};

export default M_Header;
